/**
 * Operate with keyboard.
 *
 * @module keyboard
 */

'use strict';


/**
 * Open keyboard through core intent.
 *
 * @param {Object} config - keyboard config
 * @param {Function} [callback] - invoked on successful result
 */
exports.open = function ( config, callback ) {
    core.intent({
        action: 'keyboard',
        data: {
            title: config.title,
            value: config.value || ''
        },
        events: {
            done: function ( event ) {
                var input = config.input;

                input.innerText = event.value || input.parentNode.parentNode.data.value.defaultValue;

                if ( callback ) {
                    callback(event);
                }
            }
        }
    }, function ( error ) {
        console.log(error);
    });
};
